export default __webpack_public_path__ + "static/knowledge-a707a41f7bf7b004b5fa4a9af9b18607.png";